import { isMobile } from "@/libs/detect";
import {
  MouseEvent,
  MouseEventHandler,
  TouchEvent,
  TouchEventHandler,
} from "react";

type Event<T> = MouseEvent<T> | TouchEvent<T>;
interface OnClickDependsOnPlatform<T> {
  onTouchStart?: TouchEventHandler<T>;
  onMouseDown?: MouseEventHandler<T>;
  onTouchEnd?: TouchEventHandler<T>;
}

export const makePlatformOnClick = <T>(
  onClick: (e: Event<T>) => void,
): OnClickDependsOnPlatform<T> => {
  if (isMobile) {
    return {
      onTouchStart: onClick as TouchEventHandler<T>,
      onTouchEnd(e) {
        e.preventDefault();
      },
    };
  } else {
    return {
      onMouseDown: onClick as MouseEventHandler<T>,
    };
  }
};
